import { render, staticRenderFns } from "./inputImg.vue?vue&type=template&id=7a6f82e8"
import script from "./inputImg.vue?vue&type=script&lang=js"
export * from "./inputImg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports